import { ActionButton, PageContainer } from '@if/mui'
import InteracReconciliation from '@src/components/Interac/InteracReconciliation'
import { History } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const InteracReconciliationPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer
      overline={t('interacWire.reconciliation.overline')}
      title={t('interacWire.reconciliation.title')}
      subtitle={t('interacWire.reconciliation.subtitle')}
      actions={
        <ActionButton href="/interac-history" startIcon={History}>
          {t('interacWire.reconciliation.history')}
        </ActionButton>
      }
    >
      <InteracReconciliation />
    </PageContainer>
  )
}

export default InteracReconciliationPage
